import { IUyarVT, IUyarYollar, IVT, IYollar } from "@/src/service/fikoyt-ui/interfaces/IKart.interface";
import { IAcılırKutuParametre, IParametre, ISimgeliBaslikParametre } from "@/src/service/fikoyt-ui/interfaces/IParametre/IParametre";

export const FirmaOlusturSet: IParametre[] = [
  {
    turu: "Simgeli Başlık",
    ismi: "baslikSimge",
    altAciklama: "Firmanın Logosunu Giriniz Yada Anımsatacak Bişiler",
    degeri: {
      simge: "circular industry",
      baslik: "Firma Ekle",
      altBaslik: "Sisteminize Yeni Bir Firma Ekleyebilirsiniz.",
    },
    ayarlar: {

    },
  } as ISimgeliBaslikParametre,
  {
    turu: "Resim",
    ismi: "logo",
    baslik: "Firma Logosu",
    altAciklama: "Firmanın Logosunu Giriniz Yada Anımsatacak Bişiler",
    degeri: null,
    yerTutucu: "Firma Logosu",
    ayarlar: {},
    kontroller: [
      {
        fn: `
            let dgr = itm.degeri;
            /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
            if (dgr === '' || dgr === null) { 
              itm.uyarilar.push({
                renk: "blue",
                mesaj: "Logo Alanı Eklemeniz Firmaları Daha Kolay Ayırt Etmenizi Sağlar."
              });  
            }
            /** NOT:  Tüm Testlerden Geçti */
            return true;
          `
      },
    ]
  },
  {
    turu: "Yazı",
    ismi: "ismi",
    altAciklama: "Firmanın İsmini Giriniz",
    yerTutucu: "Firma İsmi",
    baslik: "Firma İsmi",
    degeri: null,
    ayarlar: {
      solSimge: "🖋",
    },
    kontroller: [
      {
        fn: `
            let dgr = itm.degeri;
            /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
            if (dgr === '' || dgr === null) { 
              itm.hatalar.push({
                renk: "red",
                mesaj: "Firma İsmi Gereklidir."
              }); 
            }
            /** NOT:  Tüm Testlerden Geçti */
            return true;
          `
      },
    ]
  }
  ,
  {
    turu: "Yazı Alanı",
    ismi: "aciklama",
    altAciklama: "Açıklama Giriniz",
    yerTutucu: "Açıklama",
    baslik: "Açıklama",
    degeri: null,

    ayarlar: {
      solSimge: "🖋",
    },
    kontroller: [
    ]
  },
];

/** */
export const PersonelEkleSet: IParametre[] = [
  {
    turu: "Simgeli Başlık",
    ismi: "baslikSimge",
    altAciklama: "Bir Firmaya Personel Ekleyin",
    degeri: {
      simge: "circular user graduate",
      baslik: "Personel Ekle",
      altBaslik: "Bir Firmaya Personel Ekleyin",
    },
    ayarlar: {

    },
  } as ISimgeliBaslikParametre,
  {
    turu: "Resim",
    ismi: "resim",
    baslik: "Personel Resmi",
    altAciklama: "Personelin Resmini Seçiniz.",
    degeri: null,
    yerTutucu: "Personel Resmi",
    ayarlar: {},
  },

  {
    baslik: "Firma",
    ismi: "firma",
    altAciklama: "Personelin Çalıştığı Firmayı Seçiniz.",
    turu: "Açılır Kutu",
    yerTutucu: "Firma",
    ayarlar: {
      solSimge: "🏭",
      arama: true,
      silme: true,
      secenekItm: `return { value: scnk._id, label: scnk.parametreler?.[1]?.degeri }`,
      fapiAyarlar: {
        vt: "FikoYT.Uyar.firmalar",
        yol: "FikoYT.Uyar.firmalar.kalem",
        pipeFunc: `
              return [{
                $match: { "parametreler.1.degeri": { $regex: deger, $options: "i" } }
              }]
            `
      },
    },
    kontroller: [
      {
        fn: `
            let dgr = itm.degeri;
            /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
            if (dgr === '' || dgr === null) { 
              itm.hatalar.push({
                renk: "red",
                mesaj: "Firma İsmi Gereklidir."
              }); 
            }
            /** NOT:  Tüm Testlerden Geçti */
            return true;
          `
      },
    ]
  } as IAcılırKutuParametre,

  {
    turu: "Yazı",
    ismi: "ismi",
    altAciklama: "Firmanın İsmini Seçiniz",
    yerTutucu: "Personel İsmi",
    baslik: "Personel İsmi",
    degeri: null,
    ayarlar: {
      solSimge: "🖋",
    },
    kontroller: [
      {
        fn: `
              let dgr = itm.degeri;
              /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
              if (dgr === '' || dgr === null) { 
                itm.hatalar.push({
                  renk: "red",
                  mesaj: "Personel İsmi Gereklidir."
                }); 
              }
              /** NOT:  Tüm Testlerden Geçti */
              return true;
            `
      },
    ]
  },

  {
    turu: "Yazı",
    ismi: "soyismi",
    altAciklama: "Personelin Soy İsmini Giriniz",
    yerTutucu: "Personel Soy İsmi",
    baslik: "Personel Soy İsmi",
    degeri: null,
    ayarlar: {
      solSimge: "🖋",
    },
    kontroller: [
      {
        fn: `
              let dgr = itm.degeri;
              /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
              if (dgr === '' || dgr === null) { 
                itm.uyarilar.push({
                  renk: "blue",
                  mesaj: "Personelin Soy İsmini Girmeniz Daha Kolay Ayırt Etmenizi Sağlar."
                });
              }
              /** NOT:  Tüm Testlerden Geçti */
              return true;
            `
      },
    ]
  },

  {
    turu: "Yazı",
    ismi: "mobil-tel",
    altAciklama: "Personelin Mobil Telefonunu Giriniz",
    yerTutucu: "Personel Mobil Telefonu",
    baslik: "Personel Mobil Telefonu",
    degeri: null,
    ayarlar: {
      solSimge: "📱",
    },
    kontroller: [
      {
        fn: `
              let dgr = itm.degeri;
              /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
              if (dgr === '' || dgr === null) { 
                itm.uyarilar.push({
                  renk: "blue",
                  mesaj: "Personelin Mobil Telefonunu Girmeniz, Sisteminizi Kullananların Daha Kolay İletişim Kurmasını Sağlar."
                });
              }
              /** NOT:  Tüm Testlerden Geçti */
              return true;
            `
      },
    ]
  },

  {
    turu: "Yazı Alanı",
    ismi: "aciklama",
    altAciklama: "Açıklama Giriniz",
    yerTutucu: "Açıklama",
    baslik: "Açıklama",
    degeri: null,

    ayarlar: {
      solSimge: "💭",
    },
    kontroller: [
    ],
    uyarilar: [
      {
        renk: "orange", mesaj: "Açıklamalar yapay zekanın bu kişiyi tanımasına ve gerektiğinde size önermesinde oldukça yardımcı olmaktadır."
      }
    ]
  },
];

/** */
export const TeklifOlusturSet: IParametre[] = [
  {
    turu: "Simgeli Başlık",
    ismi: "baslikSimge",
    degeri: {
      simge: "circular user graduate",
      baslik: " Teklif Ekle",
      altBaslik: "Bir Firmaya Teklifte Bulunun",
    },
    ayarlar: {

    },
  } as ISimgeliBaslikParametre,
  {
    ismi: "firma",
    baslik: "Firma",
    altAciklama: "Telifi Yapacağınız Firmayı seçiniz",
    turu: "Açılır Kutu",
    yerTutucu: "Firma",
    ayarlar: {
      solSimge: "🏭",
      arama: true,
      silme: true,
      secenekItm: `return { value: scnk._id, label: scnk.parametreler?.[1]?.degeri }`,
      fapiAyarlar: {
        vt: "FikoYT.Uyar.firmalar",
        yol: "FikoYT.Uyar.firmalar.kalem",
        pipeFunc: `
            return [{
              $match: { parametreler: { $elemMatch: { ismi: "ismi", degeri: { $regex: deger ?? "", $options: "i" } } } },
            }]
          `
      },
      olaylar: {
        secimSilindi: `prm.yetkili=null;`,
        degisti: `prm.yetkili=null;`
      }
    },


  } as IAcılırKutuParametre,
  {
    ismi: "yetkili",
    baslik: "Teklif Yapılan Yetkili",
    altAciklama: "Telifi Yapacağınız Firma Yetkilisini seçiniz",
    turu: "Açılır Kutu",
    yerTutucu: "Firma Yetklisi",
    ayarlar: {
      solSimge: "👷‍♀️", silme: true, arama: true,
      secenekItm: `
          let parametreler = new Proxy({}, {
              get(_, prop: string) {
                return scnk.parametreler?.find(p => p.ismi === prop)?.degeri ?? null;
              }
            });

        return { value: scnk._id, label: (parametreler.ismi ?? '') + ' ' + (parametreler.soyismi ?? '') }`,
      fapiAyarlar: {
        vt: "FikoYT.Uyar.firmalar.personeller" as IUyarVT,
        yol: "FikoYT.Uyar.firmalar.personeller.kalem" as IUyarYollar,
        pipeFunc: `
            return [
                    {
                      "$match": {
                        "parametreler": {
                          "$elemMatch": {
                            "ismi": "firma",
                            "degeri": prm.firma ?? "aaa"
                          }
                        }
                      }
                    },
                    {
                      "$addFields": {
                        "tamAd": {
                          "$concat": [
                            {
                              "$arrayElemAt": [
                                {
                                  "$map": {
                                    "input": {
                                      "$filter": {
                                        "input": "$parametreler",
                                        "as": "p",
                                        "cond": {
                                          "$eq": [
                                            "$$p.ismi",
                                            "ismi"
                                          ]
                                        }
                                      }
                                    },
                                    "as": "p",
                                    "in": "$$p.degeri"
                                  }
                                },
                                0
                              ]
                            },
                            " ",
                            {
                              "$arrayElemAt": [
                                {
                                  "$map": {
                                    "input": {
                                      "$filter": {
                                        "input": "$parametreler",
                                        "as": "p",
                                        "cond": {
                                          "$eq": [
                                            "$$p.ismi",
                                            "soyismi"
                                          ]
                                        }
                                      }
                                    },
                                    "as": "p",
                                    "in": "$$p.degeri"
                                  }
                                },
                                0
                              ]
                            }
                          ]
                        }
                      }
                    },
                    {
                      "$match": {
                        "$or": [
                          {
                            "parametreler": {
                              "$elemMatch": {
                                "ismi": "ismi",
                                "degeri": {
                                  "$regex":
                                    deger ??
                                    "",
                                  "$options": "i"
                                }
                              }
                            }
                          },
                          {
                            "parametreler": {
                              "$elemMatch": {
                                "ismi": "soyismi",
                                "degeri": {
                                  "$regex":
                                    deger ??
                                    "",
                                  "$options": "i"
                                }
                              }
                            }
                          },
                          {
                            "tamAd": {
                              "$regex":
                                deger ??
                                "",
                              "$options": "i"
                            }
                          }
                        ]
                      }
                    }
                  ]
          `
      }
    }
  } as IAcılırKutuParametre,

  {
    ismi: "eposta_referans",
    baslik: "E-Posta Referansı",
    altAciklama: "Telifi aldığınız mailin referansını seçiniz",
    turu: "Açılır Kutu",
    yerTutucu: "E-Posta Referansı",
    ayarlar: {
      solSimge: "📨"
    }
  },

  {
    baslik: "Geçerlilik Tarihi",
    ismi: "gecerlilikTarihi",
    altAciklama: "Telifin geçerlilik tarihini seçiniz",
    turu: "Tarih Saat",
    yerTutucu: "Geçerlilik Tarihi",
    ayarlar: {
      solSimge: "📅",
      format: "dd.MM.yyyy hh:mm:ss 'Hft.'w"
    }
  },

  {
    turu: "Yazı Alanı",
    ismi: "aciklama",
    altAciklama: "Açıklama Giriniz",
    yerTutucu: "Açıklama",
    baslik: "Açıklama",
    degeri: null,

    ayarlar: {
      solSimge: "🖋",
    },
    kontroller: [
    ],
    // uyarilar: [
    //   {
    //     renk: "teal", mesaj:"Teklifle ilgili detayları yazmanız daha sonra hatırlamanıza yardımcı olacak."}
    // ]
  },
];